export default {
  apiUrlDev: 'http://localhost:8081',
  apiUrlProd: 'https://plan-api.lamusiquedelagarde.be',
  prodUrl: 'https://plan.lamusiquedelagarde.be'
};
